import { render, staticRenderFns } from "./DockLayout.vue?vue&type=template&id=feb9a5a2&scoped=true"
import script from "./DockLayout.vue?vue&type=script&lang=js"
export * from "./DockLayout.vue?vue&type=script&lang=js"
import style0 from "./DockLayout.vue?vue&type=style&index=0&id=feb9a5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb9a5a2",
  null
  
)

export default component.exports